<template>
  <transition name="modal-fade">
  <!-- Modal -->
<!-- <div class="modal" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="false">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">Modal title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
         This is a new modal header.
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div> -->

    <div class="modal-overlay">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <!-- <header class="modal-header" id="modalTitle">
          <slot name="header"> This is the default tile! </slot>
        
        </header> -->

        <section class="modal-body" id="modalDescription">
              <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            x
          </button>
          <slot name="body"> This is the default body! </slot>
        </section>

        <!-- <footer class="modal-footer">
          <slot name="footer"> This is the default footer! </slot>
          <button
            type="button"
            class="btn-green"
            @click="close"
            aria-label="Close modal"
          >
            Close me!
          </button>
        </footer> -->
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  methods: {
    close() {
      this.$emit("close");
    },
     data() {
    return {
      showModal: true
    }
  } 
  },
};
</script>

<style scoped>

.modal {
  /* position: absolute; */
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  text-align: center;
  width: fit-content;
  height: fit-content;
  max-width: 30em;
  padding: 0.5rem;
  border-radius: 1rem;
  /* box-shadow: 0 5px 5px rgb(0, 0, 0); */
  background: #FFF;
  z-index: 999;
 
  box-shadow: 2px 2px 20px 1px  rgba(145, 145, 145, 0.658) ;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  
}
.modal h1 {
  margin: 0 0 1rem;
}

.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.3);
  /* opacity: 0; */
  cursor: pointer;
   justify-content: center;
  align-items: center;
  display: flex;
}



.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.modal-back{
    background-color: rgba(0, 0, 0, 0.175);
 
}

/* .modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
} */

.modal-header,
.modal-footer {
  padding: -5px;
  display: flex;
}

.modal-header {
  position: relative;
 border:none;
  color: #4aae9b;
  justify-content: space-between;
}

.modal-footer {
     border:none;
  /* border-top: 1px solid #eeeeee; */
  flex-direction: column;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  position: absolute;
  margin-top: -40px;
  right: 0;
  border: none;
  font-size: 25px;
  padding: 0px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
